import { useEffect } from "react";
import "./App.css";
import Navigate from "./Navigates/Navigate";
import { ThemeProvider } from "@mui/material";
import createAppTheme, { loadFonts } from "./theme";
import { watchFirebaseSession } from "./features/auth/session";
import "react-toastify/dist/ReactToastify.min.css";
import "./Assets/Styles/toasts.css";

function App() {
  const theme = createAppTheme();
  useEffect(() => {
    loadFonts();
  }, []);
  useEffect(() => watchFirebaseSession(), []);
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Navigate />
      </ThemeProvider>
    </div>
  );
}
export default App;
